export default __webpack_public_path__ + "static/media/rack2.8231a54f.webp";